/* alignment-worker.js – v2 (fits delta‑lookup table) */

/*
  Key changes vs previous revision:
  ● No addition of default lengths – the CSV already stores Δ‑Shim values.
  ● Spring normalisation: input mm − 195 → ΔSpring (‑20 … +30).
  ● Reference‑row epsilon tightened to 1e‑3 for Δ values.
*/

self.addEventListener('message', async ({ data }) => {
  const { opts } = data;
  const {
    current,          // [ΔUR, ΔLF, ΔTie, ΔSpring(mm)] – still raw user input
    aim,              // [ΔCamber, ΔToe]
    tolerance,        // [tolCamber, tolToe]
    jsonUrl
  } = opts;

  const parseNum = v => parseFloat(String(v).replace(',', '.').trim()) || 0;

  // 1) Fetch JSON once ---------------------------------------------------------
  const raw = await (self.__lookup ??= fetch(jsonUrl).then(r => r.json()));
  const col = h => raw.map(r => parseNum(r[h]));

  const URear  = col('Upper Rear');
  const LFront = col('Lower Front');
  const Tie    = col('Tie');
  const Spring = col('Spring');      // ΔSpring (‑20…+30)
  const Camber = col('Camber');
  const Toe    = col('Toe');
  const Bump   = col('BumpSteer');

  // 2) Translate user spring mm → ΔSpring -------------------------------------
  const springDelta = Math.round(current[3] - 195); // 195 mm is baseline

  // 3) Build current delta vector ---------------------------------------------
  const curr = [current[0], current[1], current[2], springDelta];

  // 4) Reference row search ----------------------------------------------------
  const eq = (a, b) => Math.abs(a - b) < 1e-3;
  const ref = raw.findIndex((_, i) =>
    eq(URear[i],  curr[0]) &&
    eq(LFront[i], curr[1]) &&
    eq(Tie[i],    curr[2]) &&
    eq(Spring[i], curr[3])
  );

  if (ref < 0) {
    return postMessage({ solutions: [], debug: { err: 'Aktuelle Konfiguration nicht im Lookup', curr } });
  }

  // 5) Diff helper -------------------------------------------------------------
  const diff = i => ({
    dURear : URear [i] - URear [ref],
    dLFront: LFront[i] - LFront[ref],
    dTie   : Tie   [i] - Tie   [ref],
    dSpring: Spring[i] - Spring[ref],
    dCamber: Camber[i] - Camber[ref],
    dToe   : Toe   [i] - Toe   [ref],
    dBump  : Bump [i] - Bump [ref]
  });

  // 6) Adaptive tolerance loop -------------------------------------------------
  let tol = [...tolerance];
  let sols = [];
  const within = (x, trg, eps) => x >= trg - eps && x <= trg + eps;

  while (true) {
    sols.length = 0;

    for (let i = 0; i < raw.length; i++) {
      const d = diff(i);
      if (
        within(d.dCamber, aim[0], tol[0]) &&
        within(d.dToe,    aim[1], tol[1]) &&
        d.dSpring === 0 &&
        (Math.abs(d.dURear) + Math.abs(d.dLFront) + Math.abs(d.dTie)) > 0
      ) {
        sols.push({ ...d, shimSum: Math.abs(d.dURear) + Math.abs(d.dLFront) + Math.abs(d.dTie) });
      }
    }

    if (sols.length > 1 && sols.length < 10) break;
    if (tol[0] > 5 || tol[1] > 2) break; // abort runaway loop
    tol = tol.map(t => sols.length > 10 ? t * 0.95 : t * 1.05);
  }

  sols.sort((a, b) => a.dBump - b.dBump);
  postMessage({ solutions: sols, debug: { tol, len: sols.length, curr } });
});